module.exports = __webpack_public_path__ + "media/coffee-preferences/sub_flavor_sweet_port_wine-bf9fcb47.png";